import { Text, Image, View, Pressable } from "react-native";
import styles from "./Actualite.styles";
import dayjs from 'dayjs';
import { LoadActualite } from "../../api/Actualite/types";
import React from "react";
import FichierIcon from "./FichierIcon";

type ActualiteItemProps = {
  index: number,
  item: LoadActualite,
  onLireDetails: (actualite: any) => void ,
  onFichierJoint: () => void
}

export default function ActualiteItem({ index, item, onLireDetails, onFichierJoint }: ActualiteItemProps){
  const { libelle, date, img, description, file } = item;
  return(
    <View style={styles.taskContour}>
      <View style={styles.taskContourTitle}>
        <Text style={styles.taskTitle}>
          {libelle}
        </Text>
        <Text style={styles.taskDate}>{dayjs(date).format('DD/MM/YYYY')}</Text>
      </View>
      
      <View style={styles.taskContentContainer}>
        {/* Badge catégorie */}
        
        {/* Contenu principal */}
        <View style={styles.taskContentRow}>
          {img && (
            <View style={[styles.taskImageContainer, styles.taskImageFlex]}>
              <Image style={styles.taskImage} source={{ uri: img }} />
            </View>
          )}
          <View style={[styles.taskDescriptionContainer, styles.taskDescriptionFlex]}>
            <Text style={styles.taskItem}>
              {description}
            </Text>
          </View>
        </View>

        {/* Actions */}
        <View style={styles.taskActionsContainer}>
          <View style={styles.taskFileInfo}>
            {file && (
              <Pressable 
                onPress={onFichierJoint}
                testID={`BT_FICHIER_ACTU${index + 1}`}
              >
                <Text style={styles.taskFileText}>
                  <FichierIcon file={file} />
                  Fichier joint
                </Text>
              </Pressable>
            )}
          </View>
          
          <Pressable onPress={() => onLireDetails(item)} testID={`BT_DETAILS_ACTU${index + 1}`}>
            <Text style={styles.taskMore}>Lire plus</Text>
          </Pressable>
        </View>
      </View>
    </View>
  )
}